import React, { useState, useEffect } from "react";
import { Table, Form, Pagination, Offcanvas, } from "react-bootstrap";
import { FiEdit, FiTrash2, FiPlus, FiFilter, FiHome, FiChevronRight } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getHomework, deleteHomework } from "../../store/slices/homework";
import { getSubjectTeacher } from "../../store/slices/subjectteacher";
import toast from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const formatDate = (date) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

export default function TeacherHomework() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const teacherId = user?.data?.teacherId;

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const [standardList, setStandardList] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);

  const [standardId, setStandardId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [searchTitle, setSearchTitle] = useState("");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false);

  // fetch std and sec , sub
  useEffect(() => {
    dispatch(getSubjectTeacher({ teacherId }))
      .unwrap()
      .then((res) => {
        const grouped = {};

        (res?.data || []).forEach((item) => {
          const stdId = item.standardId?._id;
          const secId = item.sectionId?._id;
          const sub = item.subjectId;

          if (!grouped[stdId]) {
            grouped[stdId] = {
              _id: stdId,
              name: item.standardId?.name,
              sections: {},
            };
          }

          if (!grouped[stdId].sections[secId]) {
            grouped[stdId].sections[secId] = {
              _id: secId,
              name: item.sectionId?.name,
              subjects: [],
            };
          }

          if (
            sub &&
            !grouped[stdId].sections[secId].subjects.find(
              (s) => s._id === sub._id
            )
          ) {
            grouped[stdId].sections[secId].subjects.push(sub);
          }
        });

        const normalized = Object.values(grouped).map((std) => ({
          ...std,
          sections: Object.values(std.sections),
        }));

        setStandardList(normalized);
      })
      .catch(() => toast.error("Failed to fetch subject teacher data"));
  }, []);

  useEffect(() => {
    const std = standardList.find((s) => s._id === standardId);
    setSectionList(std?.sections || []);
    setSectionId("");
    setSubjectId("");
    setSubjectList([]);
  }, [standardId]);

  useEffect(() => {
    const sec = sectionList.find((s) => s._id === sectionId);
    setSubjectList(sec?.subjects || []);
    setSubjectId("");
  }, [sectionId]);

  //>>>>>>>> fetchHomework
  const fetchhomework = (filterData = {}) => {
    setIsLoading(true);

    dispatch(
      getHomework({
        teacherId,
        title: searchTitle,
        ...filterData,
      })
    )
      .unwrap()
      .then((res) => {
        setData(res?.data || []);
        setTotalData(res?.totalDataCount || 0);
        setCurrentPage(1);
      })
      .catch(() => {
        toast.error("Failed to fetch task list");
        setData([]);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchhomework();
  }, []);

  const editNavigatedata = (id) => {
    navigate(`/teacher/edit-homework/${id}`);
  };

  const handleDeleteRow = (id) => {
    if (!window.confirm("Delete this homework?")) return;

    dispatch(deleteHomework(id))
      .unwrap()
      .then(() => {
        toast.success("Homework details deleted");
        fetchhomework();
      })
      .catch((error) => {
        console.log(error)
        toast.error("deleted Homework details failed")
      })
  };

  // ------- >handle filter
  const handleFilter = () => {

    fetchhomework({ standardId, sectionId, subjectId });
    setShowFilterDrawer(false);
  };

  // clear btn--------
  const handleClear = () => {
    setStandardId("");
    setSectionId("");
    setSubjectId("");
    setSearchTitle("");
    setSectionList([]);
    setSubjectList([]);
    fetchhomework();
  };

  // ----------- > export
  const handleExport = () => {
    if (!data.length) {
      toast.error("No data to export");
      return;
    }

    const headers = [
      "Class",
      "Subject",
      "Title",
      "Assign Date",
      "Due Date",
    ];

    const rows = data.map((d) => [
      `${d.standardId?.name}-${d.sectionId?.name}`,
      d.subjectId?.name,
      d.title,
      formatDate(d.assignDate),
      formatDate(d.dueDate),
    ]);

    const csv =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((r) => r.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = csv;
    link.download = "homework_records.csv";
    link.click();
  };

  // ------ pagination
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          {/* Left */}
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/teacher/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />
            <span className="active">Homework</span>
          </div>

          {/* Right */}
          <div className="d-flex align-items-center gap-2 flex-wrap">

            <button
              className="btn-cancel d-flex align-items-center gap-2"
              onClick={() => setShowFilterDrawer(true)}
            >
              <FiFilter />
              <span className="d-none d-md-inline">Filter</span>
            </button>


            <Link
              to="/teacher/add-homework"
              className="add-btn"
            >
              <FiPlus />
              Add Homework
            </Link>

          </div>

        </div>
      </div>
      <div className="staff-card">
        {/* ----------- > top bar  */}

        {/* table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Class-Sec</th>
                <th className="text-center">Subject</th>
                <th className="text-center">Title</th>
                <th className="text-center">Assign Date</th>
                <th className="text-center">Due Date</th>
                <th className="text-center">Description</th>
                <th className="text-center">File</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index}>
                    <td><Skeleton width={20} /></td>
                    <td><Skeleton width={100} /></td>
                    <td><Skeleton width={80} /></td>
                    <td><Skeleton width={150} /></td>
                    <td><Skeleton width={90} /></td>
                    <td><Skeleton width={90} /></td>
                    <td><Skeleton width="100%" height={18} /></td>
                    <td><Skeleton width={45} /></td>
                    <td>
                      <div className="d-flex justify-content-center gap-2">
                        <Skeleton circle width={32} height={32} />
                        <Skeleton circle width={32} height={32} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : paginatedData.length > 0 ? (
                paginatedData.map((item, i) => (
                  <tr key={item._id}>
                    <td className="text-center">{startIndex + i + 1}</td>
                    <td className="text-center">
                      {item.standardId?.name}-{item.sectionId?.name}
                    </td>
                    <td className="text-center">{item.subjectId?.name}</td>
                    <td className="text-center">{item.title}</td>
                    <td className="text-center">{formatDate(item.assignDate)}</td>
                    <td className="text-center">{formatDate(item.dueDate)}</td>
                    <td
                      className="text-center"
                      style={{
                        width: "150px",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                      }}
                    >
                      {item.description}
                    </td>
                    <td className="text-center">
                      {item.file ? (
                        <a href={item.file} target="_blank" rel="noreferrer">
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="text-center">
                      <button
                        className="edit-btn me-2"
                        onClick={() => editNavigatedata(item._id)}
                      >
                        <FiEdit size={16} />
                      </button>

                      <button
                        className="edit-btn"
                        onClick={() => handleDeleteRow(item._id)}
                      >
                        <FiTrash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-5">
                    <div className="d-flex flex-column align-items-center">

                      <h6 className="mt-3 mb-1 text-muted">No Homework Found</h6>
                      <p className="text-secondary mb-0">
                        There are no homework records available.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div>

      {/* ----------- > right side drawer */}
      <Offcanvas
        show={showFilterDrawer}
        onHide={() => setShowFilterDrawer(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filter Homework</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Form.Select
            className="mb-3"
            value={standardId}
            onChange={(e) => setStandardId(e.target.value)}
          >
            <option value="">Select Standard</option>
            {standardList.map((std) => (
              <option key={std._id} value={std._id}>
                {std.name}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            className="mb-3"
            value={sectionId}
            disabled={!standardId}
            onChange={(e) => setSectionId(e.target.value)}
          >
            <option value="">Select Section</option>
            {sectionList.map((sec) => (
              <option key={sec._id} value={sec._id}>
                {sec.name}
              </option>
            ))}
          </Form.Select>

          <Form.Select
            className="mb-3"
            value={subjectId}
            disabled={!sectionId}
            onChange={(e) => setSubjectId(e.target.value)}
          >
            <option value="">Select Subject</option>
            {subjectList.map((sub) => (
              <option key={sub._id} value={sub._id}>
                {sub.name}
              </option>
            ))}
          </Form.Select>

          <div className="d-flex gap-2">
            <button className="btn-submit w-100" onClick={handleFilter}>
              Apply
            </button>
            <button className="btn-cancel w-100" onClick={handleClear}>
              Clear
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>


    </>
  );
}
